export type Rectangle<T> = {
  readonly width: T
  readonly height: T
}
